const customModalStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		width: '30%',
		borderRadius: '24px',
		boxShadow: '0px 6px 58px 0px #7991AD32',
		border: 'none',
        overflow: 'auto',
        maxHeight: '90vh',
        padding: '40px 60px'
	},
};

export default customModalStyles;
